<template>
    <div id="global-search-root">
        <div id="global-search" :class="{ 'is-visible': this.$parent.searchIsExpanded }">
            <div id="global-search-left">
                <logo/>
                <a href="#" v-on:click="commitMutation('toggleGlobalSearch')">
                    <b-icon icon="arrow-left"></b-icon>
                </a>
            </div>
            <div id="global-search-right">
                <div class="global-search-form">
                    <h6 class="title is-6" v-on:click="focusSearch">
                        Global Search
                        <span class="help">Search across all your companies, projects, properties and more...</span>
                    </h6>
                    <form action="" style="position: relative">
                        <input id="global-search-input"
                                ref="GlobalSearch"
                                class="input"
                                type="text"
                                placeholder="Search..."
                                v-model="searchTerm">
                        <button type="reset" class="button is-text reset" v-if="globalSearchTerm" @click="clearSearch">
                            <b-icon icon="times-circle"></b-icon>
                        </button>
                    </form>
                </div>

                <div class="global-search-results">
                    <template v-if="isGlobalSearchActive">
                        <custom-scrollbar>
                            <div v-for="searchResult in globalSearchResults"
                                 class="global-search-results-group"
                                 :key="searchResult.id">
                                <p class="subtitle is-6 is-uppercase">
                                    {{ searchResult.name }}
                                </p>
                                <template v-if="!searchResult.pending && !searchResult.results.length">
                                    <div class="notification is-size-7 has-text-centered">
                                        No results found.
                                    </div>
                                </template>
                                <template v-else-if="!searchResult.pending">
                                    <div class="global-search-result" v-if="searchResult.name === 'Accounts'">
                                        <router-link
                                                v-on:click.native="commitMutation('toggleGlobalSearch')"
                                                :to="'/accounts/'+match.id"
                                                v-for="match in searchResult.results"
                                                :key="match.id">
                                            <div class="global-search-result-icon has-text-centered">
                                                <span class="icon is-large">
                                                    <span class="fa-stack">
                                                        <i class="fas fa-circle fa-stack-2x"></i>
                                                        <i class="fas fa-briefcase fa-stack-1x fa-inverse"></i>
                                                    </span>
                                                </span>
                                            </div>
                                            <div class="global-search-result-details">
                                                <strong>{{ match.name }}</strong>
                                                <div><span>Company: {{ match.company }}</span></div>
                                                <div><span>Status: {{ match.status }}</span></div>
                                            </div>
                                        </router-link>
                                    </div>

                                    <div class="global-search-result" v-if="searchResult.name === 'Account Properties'">
                                        <router-link
                                                :to="{name: 'account-properties', params: {id: match.account_id, prop_id: match.id}}"
                                                v-for="match in searchResult.results"
                                                :key="match.id">
                                            <div class="global-search-result-icon has-text-centered">
                                                <span class="icon is-large">
                                                    <span class="fa-stack">
                                                        <i class="fas fa-circle fa-stack-2x"></i>
                                                        <i class="fas fa-map-pin fa-stack-1x fa-inverse"></i>
                                                    </span>
                                                </span>
                                            </div>
                                            <div class="global-search-result-details">
                                                <strong>{{ match.address }}</strong>
                                                <div><span>Account: {{ match.account_name }}</span></div>
                                            </div>
                                        </router-link>
                                    </div>

                                    <div class="global-search-result" v-if="searchResult.name === 'Companies'">
                                        <router-link :to="'/companies/' + match.id"
                                                     v-for="match in searchResult.results"
                                                     :key="match.id">
                                            <div class="global-search-result-icon has-text-centered">
                                                <span class="icon is-large">
                                                    <span class="fa-stack">
                                                        <i class="fas fa-circle fa-stack-2x"></i>
                                                        <i class="far fa-building fa-stack-1x fa-inverse"></i>
                                                    </span>
                                                </span>
                                            </div>
                                            <div class="global-search-result-details">
                                                <strong>{{ match.name }}</strong>
                                                <div><span>Subscriptions: {{ match.subscriptions }}</span></div>
                                            </div>
                                        </router-link>
                                    </div>

                                    <div class="global-search-result" v-if="searchResult.name === 'Users'">
                                        <router-link
                                                :to="'/users/' + match.id"
                                                v-for="match in searchResult.results"
                                                :key="match.id">
                                            <div class="global-search-result-icon has-text-centered">
                                                <span class="icon is-large">
                                                    <span class="fa-stack">
                                                        <i class="fas fa-circle fa-stack-2x"></i>
                                                        <i class="fas fa-users fa-stack-1x fa-inverse"></i>
                                                    </span>
                                                </span>
                                            </div>
                                            <div class="global-search-result-details">
                                                <strong>{{ match.name }}</strong>
                                                <div><span>{{ match.email }}</span></div>
                                                <div><span>Company: {{ match.company }}</span></div>
                                            </div>
                                        </router-link>
                                    </div>

                                    <div class="global-search-result" v-if="searchResult.name === 'Subscriptions'">
                                        <router-link
                                                :to="'/subscriptions/' + match.id"
                                                v-for="match in searchResult.results"
                                                :key="match.id">
                                            <div class="global-search-result-icon has-text-centered">
                                                <span class="icon is-large">
                                                    <span class="fa-stack">
                                                        <i class="fas fa-circle fa-stack-2x"></i>
                                                        <i class="fas fa-coins fa-stack-1x fa-inverse"></i>
                                                    </span>
                                                </span>
                                            </div>
                                            <div class="global-search-result-details">
                                                <strong>{{ match.name }}</strong>
                                                <div><span>{{ match.companies }} Companies</span></div>
                                                <div><span>{{ match.price }} Default price</span></div>
                                            </div>
                                        </router-link>
                                    </div>

                                    <div class="global-search-result" v-if="searchResult.name === 'Roles'">
                                        <router-link
                                                :to="'/roles/' + match.id"
                                                v-for="match in searchResult.results"
                                                :key="match.id">
                                            <div class="global-search-result-icon has-text-centered">
                                                <span class="icon is-large">
                                                    <span class="fa-stack">
                                                        <i class="fas fa-circle fa-stack-2x"></i>
                                                        <i class="fas fa-users-cog fa-stack-1x fa-inverse"></i>
                                                    </span>
                                                </span>
                                            </div>
                                            <div class="global-search-result-details">
                                                <strong>{{ match.name }}</strong>
                                                <div><span>{{ match.companies }} Companies</span></div>
                                            </div>
                                        </router-link>
                                    </div>

                                </template>
                                <template v-else>
                                    <div class="has-text-centered">
                                        <div style="padding: 0.75rem">
                                            <b-icon pack="fas" icon="sync-alt" custom-class="fa-spin"></b-icon>
                                        </div>
                                        <div class="is-size-7">
                                            <em>Loading {{ searchResult.name }}...</em>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </custom-scrollbar>
                    </template>
                    <div class="has-text-centered is-size-7" style="padding: 1.75rem;" v-else>
                        Enter a search term above to begin searching
                    </div>
                </div>

            </div>
        </div>
        <div id="overlay" :class="{ 'is-visible': this.$parent.searchIsExpanded }" @click.prevent="closeSearchModal"></div>
    </div>
</template>

<script>
import _ from 'lodash'
import Logo from '../Icons/Logo'
import { mapState, mapGetters, mapActions } from 'vuex'
import CustomScrollbar from '../Elements/CustomScrollbar'

export default {
  name: 'GlobalSearch',
  data () {
    return {
      searchTerm: null
    }
  },
  components: {
    'logo': Logo,
    CustomScrollbar
  },
  methods: {
    ...mapActions([
      'doGlobalSearch',
      'clearGlobalSearch'
    ]),
    commitMutation (mutation) {
      this.$store.commit(mutation)
    },
    focusSearch () {
      this.$refs.GlobalSearch.focus()
    },
    clearSearch () {
      this.clearGlobalSearch()
      this.searchTerm = null
    },
    closeSearchViaEscape (e) {
      e.stopImmediatePropagation()
      if (e.keyCode !== 27) return

      this.$store.commit('toggleGlobalSearch')
    },
    closeSearchModal () {
      this.$store.commit('toggleGlobalSearch')
    }
  },
  computed: {
    ...mapState([
      'searchIsExpanded',
      'overlayIsVisible'
    ]),
    ...mapGetters([
      'globalSearchResults',
      'isGlobalSearchActive',
      'globalSearchTerm'
    ])
  },
  watch: {
    searchIsExpanded: function (val) {
      setTimeout(() => this.focusSearch(), 100)
      if (val) {
        document.addEventListener('keyup', this.closeSearchViaEscape)
      } else {
        document.removeEventListener('keyup', this.closeSearchViaEscape)
      }
    },
    searchTerm: _.debounce(function (newVal) {
      this.doGlobalSearch(newVal)
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Nav/GlobalSearch.vue